import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const termsOfServiceTitle = 'Terms of Service';

export const termsOfServiceSections: LegalSection[] = [
  {
    id: 'agreement',
    title: 'Agreement to Terms',
    paragraphs: [
      `These Terms of Service (“Terms”) govern your use of ${LEGAL_META.brandMark}, ${LEGAL_META.siteName}, and related applications and services (the “Services”) operated by us.`,
      `${LEGAL_META.operatorLine}`,
      'By creating an account or using the Services, you agree to these Terms and our Privacy Policy. If you do not agree, do not use the Services.',
    ],
  },
  {
    id: 'eligibility',
    title: 'Eligibility',
    paragraphs: [
      `You must be at least ${LEGAL_META.minimumAge} years old to use the Services. The Services are not directed to anyone under ${LEGAL_META.minimumAge}, and we do not knowingly permit such use.`,
      'You represent that you have the legal capacity to enter into these Terms and that information you provide is accurate.',
    ],
  },
  {
    id: 'account',
    title: 'Your Account',
    paragraphs: [
      'You are responsible for safeguarding your credentials and for activity on your account.',
      'You may delete your account at any time in the App under Settings → Account → Delete account.',
    ],
  },
  {
    id: 'content-license',
    title: 'Your Content and License',
    paragraphs: [
      'You retain ownership of content you submit. By posting content, you grant us a non-exclusive, worldwide, royalty-free license to host, store, display, distribute, and otherwise use your content solely to operate and improve the Services, including making content available to other users as you direct through the product.',
      'This license continues for content that remains on the Services and ends when you delete content or your account, subject to reasonable backup and legal retention periods described in our Privacy Policy.',
    ],
  },
  {
    id: 'prohibited',
    title: 'Prohibited Conduct and Content',
    paragraphs: ['You agree not to post or engage in conduct that:'],
    listItems: [
      'Violates law or third-party rights, including copyright and privacy.',
      'Includes child sexual abuse material, exploitation of minors, or content primarily intended for sexual gratification.',
      'Harasses, threatens, bullies, or promotes hatred or violence against individuals or groups.',
      'Is fraudulent, spam, or misleading, including false location tags.',
      'Distributes malware or attempts to compromise the Services.',
      'Uses the Services for unauthorized commercial solicitation without our written consent.',
    ],
  },
  {
    id: 'moderation',
    title: 'Moderation and Reporting',
    paragraphs: [
      'We may remove content or suspend accounts that violate these Terms or our Community Guidelines, with or without notice.',
      'Report concerns via in-app reporting where available or email ' +
        LEGAL_META.supportEmail +
        '. We aim to review reports within 24 hours for urgent safety issues.',
      'See our Community Guidelines for more detail.',
    ],
  },
  {
    id: 'third-party',
    title: 'Third-Party Services and Links',
    paragraphs: [
      'The Services may integrate with third-party sign-in, maps, or sharing apps. Your use of third-party services is subject to their terms.',
      'We are not responsible for third-party websites or services linked from the Services. Use them at your own risk.',
    ],
  },
  {
    id: 'disclaimer',
    title: 'Disclaimers',
    paragraphs: [
      'THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, TO THE MAXIMUM EXTENT PERMITTED BY LAW.',
    ],
  },
  {
    id: 'liability',
    title: 'Limitation of Liability',
    paragraphs: [
      'TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICES.',
      'OUR TOTAL LIABILITY FOR ANY CLAIM ARISING FROM THE SERVICES WILL NOT EXCEED THE GREATER OF ONE HUNDRED U.S. DOLLARS (US$100) OR THE AMOUNT YOU PAID US IN THE TWELVE MONTHS BEFORE THE CLAIM.',
    ],
  },
  {
    id: 'indemnity',
    title: 'Indemnity',
    paragraphs: [
      'You agree to defend, indemnify, and hold us harmless from claims arising from your content, your use of the Services, or your violation of these Terms or third-party rights.',
    ],
  },
  {
    id: 'eu-consumer',
    title: 'EU and UK Consumers',
    paragraphs: [
      'If you are a consumer in the European Union or United Kingdom, mandatory consumer protection laws in your country of residence may give you rights that cannot be waived by these Terms.',
      'You may use the EU online dispute resolution platform at https://ec.europa.eu/consumers/odr if applicable.',
    ],
  },
  {
    id: 'governing-law',
    title: 'Governing Law and Disputes',
    paragraphs: [
      `These Terms are governed by the laws of the State of ${LEGAL_META.governingState}, without regard to conflict-of-law principles.`,
      `Except where prohibited by applicable consumer law, disputes will be brought in state or federal courts located in ${LEGAL_META.governingVenue}, and you consent to personal jurisdiction there.`,
      'Any cause of action must commence within one (1) year after it arose, to the extent permitted by law.',
    ],
  },
  {
    id: 'changes-terms',
    title: 'Changes',
    paragraphs: [
      'We may modify these Terms at any time. Continued use after changes constitutes acceptance. Material changes may be communicated in the App or on the website.',
    ],
  },
  {
    id: 'contact-terms',
    title: 'Contact',
    paragraphs: [
      `Questions: ${LEGAL_META.contactEmail}`,
      `${LEGAL_META.legalEntityName}`,
    ],
  },
];
